export default {"icons":{"iconfont":"mdi","values":{}}}
